import React, { useEffect, useContext } from 'react';
import { string, arrayOf } from 'prop-types';

import { useConfigService } from '@thd-nucleus/experience-context';
import { extend, QueryProvider, QueryContext, useDataModel } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

import { BundlesDataModel } from '../models/dataModel';
import { filterHiddenDiscontinuedProducts, getComponentImpressionData, getUpdatedBundle } from '../utils/product-utils';
import { getTemplate } from '../subcomponents/templates/index';

const BundleMini = ({ bundleIds, name }) => {
  const { defaultVariables } = useContext(QueryContext);
  const isValidBundleIds = bundleIds && Array.isArray(bundleIds) && bundleIds?.length > 0;
  const configExperienceType = useConfigService('bundleExperience') || null;
  const configBundleType = useConfigService('bundleType') || null;

  const { data, loading } = useDataModel('products', {
    variables: {
      itemIds: bundleIds
    },
    skip: !isValidBundleIds
  });

  const bundles = filterHiddenDiscontinuedProducts(data?.products) || [];

  const triggerErrorEvent = () => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('bundle-mini.error');
  };

  const noBundles = !loading && bundles.length === 0;

  useEffect(() => {
    if (noBundles) {
      triggerErrorEvent();
    }
  }, [noBundles]);

  if (noBundles) {
    return null;
  }

  const bundleData = getUpdatedBundle(bundles?.[0], configExperienceType, configBundleType);
  const templateName = bundleData?.features?.templates?.item;
  const ItemTemplate = getTemplate(templateName);

  if (!ItemTemplate) {
    return null;
  }

  return (
    <ImpressionProvider
      data={getComponentImpressionData({
        bundleData,
        slotId: name
      })}
    >
      <QueryProvider
        cacheKey={`bundle-mini-item-${templateName}`}
        defaultVariables={defaultVariables?.current}
        dataSource="bundleMiniItem"
      >
        <ItemTemplate
          bundleLoading={loading}
          bundleData={bundleData}
          onError={triggerErrorEvent}
        />
      </QueryProvider>
    </ImpressionProvider>
  );
};

BundleMini.propTypes = {
  bundleIds: arrayOf(string.isRequired),
  name: string
};

BundleMini.defaultProps = {
  bundleIds: [],
  name: ''
};

BundleMini.displayName = 'BundleMini';

BundleMini.dataModel = extend(
  BundlesDataModel
);

export { BundleMini };